import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { bridge } from './bridge'
import { bootstrapRegistration } from './store/bootstrap'
// api/ws side-effects (bridge.on listeners + the agentInstances
// subscriber for deferred push-tap navigation) only register when the
// module evaluates. App → AgentsScreen pulls it in transitively, but
// import it explicitly here so the listeners are wired before we tell
// native we're ready, regardless of how App's import graph evolves.
import './api/ws'
import './styles/global.css'

// Keep --vvh in sync with visualViewport.height so CSS can size the app
// container to the area actually visible above the keyboard. Fallback to
// innerHeight on platforms that don't expose visualViewport (older WKs).
// Needs to run before first paint so the initial layout uses the right
// height — bootstrapRegistration is async, but the viewport is stable
// throughout that window.
function syncVVH() {
  const h = window.visualViewport?.height ?? window.innerHeight
  document.documentElement.style.setProperty('--vvh', `${h}px`)
}
syncVVH()
window.visualViewport?.addEventListener('resize', syncVVH)
window.visualViewport?.addEventListener('scroll', syncVVH)
window.addEventListener('orientationchange', syncVVH)

// Check keychain for existing creds before first render so returning users
// don't flash the RegistrationScreen for a tick.
bootstrapRegistration().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
  // Tell native that all `bridge.on` listeners have registered so any
  // events queued during cold launch (e.g. push.tapped from a
  // notification that opened the app) can flush. Resolves to a no-op
  // on the mock bridge.
  bridge.call('bridge.ready').catch(() => {})
})
